import { convertStyle } from "../../../react/react"
import { IFieldYearViewModel } from "../types"
import { getCroppingStyle, getDisabledYearContent } from "./content"
import { TimelineComponentProps } from "./types"

interface Props extends Pick<TimelineComponentProps, "vm" | "onPointerDown"> {
    year: IFieldYearViewModel,
    relativeTop?: number
}

export function SingleDisabledField({ vm, onPointerDown, year, relativeTop }: Props) {

    const style = convertStyle(getCroppingStyle(vm, year, relativeTop))

    return (

        <div
            key={year.id}
            className={`tl-disabled-year ${year.disabled ? null : 'active'} `}
            style={style}
            onPointerDown={e => onPointerDown(e, year)}>

            <div className="inner" dangerouslySetInnerHTML={{ __html: getDisabledYearContent(vm, year) }}>
            </div>

        </div>

    )
}
